import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import getQueryParams from '@/utils/getQueryParams';
import store from '@/store/BookingStore';
import { createRequestData } from '@/logic/createRequestParams';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { Booking, StatusV2 } from '../../../../../requests-module/src';
import checkIsPackageTrain from '@/logic/options/checkIsPackageTrain';

export const flightStep = new FunnelStep({
    name: RouteNameEnum.Flight,
    dependencies: [],
    init: async () => {
        const queryParams = getQueryParams()

        if (queryParams.prest_id === 'TNE' || checkIsPackageTrain(store.getters.getBooking)) {
            return '/train'
        }

        let response: Booking | { error: string } | null = null
        if (!store.getters.getToken) {
            console.log('init(): Initializing Flight Page - make an init call to get BO with defaults');
            // no bo - create one from url 
            const requestData = createRequestData(queryParams);
            if (!requestData.origin) {
                return '/options'
            }

            response = await BookingFunnelService.initBookingFlight(requestData)
            if ('error' in response) {
                throw new Error('Error with api')
            }

            store.commit('setToken', response.boReference)

            if (checkIsPackageTrain(store.getters.getBooking)) {
                return '/train'
            }
        } else {
            console.log('init(): Initializing Flight Page - if bo exist, just make a refresh call');
            // has bo, make a refresh call with alt options
            response = await BookingFunnelService.refreshBookingFlight()
            if ('error' in response) {
                throw new Error('Error with api')
            }

            if (response.status == StatusV2.PROCESSING) {
                // proccesing payment go to /payment page
                return '/payment'
            }

            if (response.status == StatusV2.SUCCESS) {
                return '/paid'
            }

            // if (!checkIsPackageFlight(response)) {
            //     return '/options'
            // }
            return false
        }
    },

    hasToBeLoggedIn: false
});